<template>
  <BaseDialog
    contentClass="profile-field-category"
    ref="dialog"
    :show-actions="true"
    sidePanel
    white-content
    @closeModal="closeDialog"
  >
    <template slot="title">{{ titleText }}</template>
    <template slot="content">
      <form @submit.prevent="onSubmit" novalidate class="profile-field-category__form">
        <FormInput
          ref="nameInput"
          :label="$t('page.admin-tenant-profile.category-dialog.category-label')"
          has-gray-background
          name="categoryName"
          isRequired
          v-model="name"
        />
        <div class="profile-field-category__actions">
          <BaseButton is-large type="submit" :disabled="!name.trim()" :is-outlined="!name.trim()">
            {{ titleText }}
          </BaseButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import BaseDialog from '@/components/base/BaseDialog';
import FormInput from '@/components/form/FormInput.vue';

export default {
  name: 'ProfileFieldCategoryDialog',
  components: { BaseButton, BaseDialog, FormInput },
  data() {
    return {
      mode: 'add',
      categoryId: null,
      name: '',
    };
  },
  computed: {
    titleText() {
      return this.mode === 'edit' ? this.$t('actions.edit') : this.$t('page.admin-tenant-profile.add-category');
    },
  },
  methods: {
    openAdd() {
      this.mode = 'add';
      this.categoryId = null;
      this.name = '';
      this.$refs.dialog.openModal();
    },
    openEdit(category) {
      this.mode = 'edit';
      this.categoryId = category.id;
      this.name = category.name;
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      if (!this.name.trim()) return;
      this.$emit('submit', { mode: this.mode, categoryId: this.categoryId, name: this.name.trim() });
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__profile-field-category {
  .profile-field-category__actions {
    display: flex;
    justify-content: center;
    padding-top: $space-xl;
  }
}
</style>
